module.exports = __webpack_public_path__ + "img/new-guest.1bbf6cdf.svg";